import { LdLabel, LdRadio } from "@liquid/react";
import {
  FieldValues,
  Path,
  useController,
  useFormContext,
} from "react-hook-form";

import { OptionType } from "@src/types";

type FormRadioButtonProps<FormData extends FieldValues> = {
  name: Path<FormData>;
  option: OptionType;
  onChange: any;
};
function FormRadioButton<FormData extends FieldValues>({
  option,
  name,
  onChange,
}: FormRadioButtonProps<FormData>) {
  const { clearErrors, control } = useFormContext();

  const { field } = useController({
    name,
    control,
    rules: {
      required: true,
    },
  });

  return (
    <LdLabel position="right" size="m">
      {option.label}
      <LdRadio
        checked={field.value === option.value}
        name={field.name}
        value={option.value}
        id={option.value}
        disabled={option.disabled}
        onLdinput={(e) => {
          field.onChange(e.target.value);
          clearErrors(name);
          if (onChange && typeof onChange === "function") {
            onChange(e.target.value);
          }
        }}
        data-testid={`${name}-formRadioButton-option`}
        ref={null}
      />
    </LdLabel>
  );
}

export { FormRadioButton };
